// TODO columns should come from BE
// const dataStructure = {
//   key: "",
//   order: 0,
//   label: "",
//   enableResizing: true,
//   enableSorting: true,
//   size: 200,
// };

import React from "react";

export const columns = () => {
  return [
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "code",
      header: "ID",
      cell: ({ row }) => <div>{row.getValue("code")}</div>,
      enableSorting: true,
    },
  ];
};
